export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    PouffeBase: 1,
    PouffeFabric: 1,
    CupboardsSaloon: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    CupboardsAftCabin: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: 'BeautyBox'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/ownerscabin.js